import React, { useState, useEffect } from "react";
import VideoModal from "../VideoModal/VideoModal";
import { useNavigate, Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay, Thumbs } from "swiper/modules";
import "swiper/swiper-bundle.css";
import "./Slider.css";

export const CategorySlider = ({ category }) => {
  const navigate = useNavigate();
  const [loadingStates, setLoadingStates] = useState([]);

  useEffect(() => {
    if (category && category.length > 0) {
      const updatedLoadingStates = category.map(() => true);
      setLoadingStates(updatedLoadingStates);

      category.forEach((item, index) => {
        const img = new Image();
        img.src = item.imgUrl;

        if (img.complete) {
          handleImageLoad(index);
        }
      });
    }
  }, [category]);

  const handleImageLoad = (index) => {
    setLoadingStates((prevState) => {
      const newState = [...prevState];
      newState[index] = false;
      return newState;
    });
  };

  const breakpoints = {
    1024: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    300: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
  };

  return (
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      slidesPerView={1}
      breakpoints={breakpoints}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      loop={true}
      // centerInsufficientSlides={!category.length < 5}
      className="category-slider"
    >
      {category &&
        category.map((item, index) => (
          <SwiperSlide key={item.id}>
            <div
              className="category-box-h3"
              onClick={() => navigate(`/view-category/${item.id}`)}
            >
              <div className="category-box">
                {loadingStates[index] ? (
                  <p className="skeleton-loader-category">ছবি লোড হচ্ছে...</p>
                ) : null}
                <img
                  src={item.imgUrl}
                  alt={item.name}
                  onLoad={() => handleImageLoad(index)}
                  style={{ display: loadingStates[index] ? "none" : "block" }}
                />
              </div>
              <h3>{item.name}</h3>
            </div>
          </SwiperSlide>
        ))}
    </Swiper>
  );
};

export const HeroSlider = ({ heroSlices }) => {
  const [loadingStates, setLoadingStates] = useState([]);

  useEffect(() => {
    if (heroSlices && heroSlices.length > 0) {
      setLoadingStates(Array(heroSlices.length).fill(true));

      heroSlices.forEach((item, index) => {
        const img = new Image();
        img.src = item.image;

        if (img.complete) {
          handleImageLoad(index);
        }
      });
    }
  }, [heroSlices]);

  const handleImageLoad = (index) => {
    setLoadingStates((prevState) => {
      const newState = [...prevState];
      newState[index] = false;
      return newState;
    });
  };

  return (
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      navigation
      pagination={{ clickable: true }}
      slidesPerView={1}
      autoplay={{ delay: 3000, disableOnInteraction: false }}
      loop={true}
      className="hero-slider"
    >
      {heroSlices &&
        heroSlices.map((item, index) => (
          <SwiperSlide key={item.id}>
            <div className="hero-slider-container">
              {loadingStates[index] ? (
                <p className="skeleton-loader-hero">ছবি লোড হচ্ছে...</p>
              ) : null}
              <Link to={item.url}>
                <img
                  src={item.image}
                  alt="hero-image"
                  onLoad={() => handleImageLoad(index)}
                  style={{ display: loadingStates[index] ? "none" : "block" }}
                />
              </Link>
            </div>
          </SwiperSlide>
        ))}
    </Swiper>
  );
};

export const ProductSlider = ({ data }) => {
  const [videoModalOpen, setVideoModalOpen] = useState(false);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  let totalImages = data?.images?.filter((item) => {
    return item.url;
  });

  const handleVideoOpen = () => setVideoModalOpen(true);
  const handleVideoClose = () => setVideoModalOpen(false);

  const slides = [];

  if (data?.video) {
    slides.push({
      type: "video",
      id: "video",
      thumbnail:
        data?.images && data.images.length > 0
          ? data.images[0].url
          : "https://via.placeholder.com/560x315?text=No+Thumbnail",
      videoUrl: data.video,
    });
  }

  if (data?.images) {
    data.images.forEach((item) => {
      if (!item.url) return;
      slides.push({
        type: "image",
        id: item.id,
        url: item.url,
        thumbnail: item.url,
      });
    });
  }

  return (
    <div className="product-slider-container">
      <Swiper
        modules={[Navigation, Pagination, Autoplay, Thumbs]}
        thumbs={{ swiper: thumbsSwiper }}
        slidesPerView={1}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop={totalImages.length >= 4}
        className="product-slider-main"
      >
        {slides.map((slide) => {
          if (slide.type === "video") {
            return (
              <SwiperSlide key={slide.id}>
                <div className="video-thumbnail" onClick={handleVideoOpen}>
                  <img
                    src={slide.thumbnail}
                    alt="Video Thumbnail"
                    style={{ width: "100%", display: "block" }}
                  />
                  <div className="play-button-overlay">
                    <svg
                      width="60"
                      height="60"
                      viewBox="0 0 24 24"
                      fill="white"
                      stroke="black"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polygon points="5 3 19 12 5 21 5 3"></polygon>
                    </svg>
                  </div>
                </div>
              </SwiperSlide>
            );
          } else {
            return (
              <SwiperSlide key={slide.id}>
                <img
                  src={slide.url}
                  alt="Product"
                  style={{ width: "100%", display: "block" }}
                />
              </SwiperSlide>
            );
          }
        })}
      </Swiper>

      <Swiper
        onSwiper={setThumbsSwiper}
        modules={[Navigation, Thumbs]}
        slidesPerView={totalImages.length}
        spaceBetween={10}
        watchSlidesProgress={true}
        className="product-slider-thumbs"
      >
        {slides.map((slide) => {
          if (slide.type === "video") {
            return (
              <SwiperSlide key={slide.id}>
                <div
                  className="thumb-item"
                  onClick={handleVideoOpen}
                  style={{ position: "relative", cursor: "pointer" }}
                >
                  <img
                    src={slide.thumbnail}
                    alt="Video Thumbnail"
                    style={{ width: "100%", display: "block" }}
                  />
                  <div className="thumb-play-button-overlay">
                    <svg
                      width="30"
                      height="30"
                      viewBox="0 0 24 24"
                      fill="white"
                      stroke="black"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polygon points="5 3 19 12 5 21 5 3"></polygon>
                    </svg>
                  </div>
                </div>
              </SwiperSlide>
            );
          } else {
            return (
              <SwiperSlide key={slide.id}>
                <img
                  src={slide.thumbnail}
                  alt="Thumbnail"
                  style={{ width: "100%", display: "block", cursor: "pointer" }}
                />
              </SwiperSlide>
            );
          }
        })}
      </Swiper>
      <VideoModal
        open={videoModalOpen}
        onClose={handleVideoClose}
        videoUrl={data.video}
      />
    </div>
  );
};

export const ProductCategorySlider = ({ data }) => {
  const navigate = useNavigate();

  const breakpoints = {
    350: {
      slidesPerView: 3,
      spaceBetween: 60,
    },
    300: {
      slidesPerView: 3,
      spaceBetween: 0,
    },
  };

  return (
    <Swiper
      modules={[Navigation, Autoplay]}
      navigation
      pagination={{ clickable: true }}
      breakpoints={breakpoints}
      autoplay={{ delay: 500, disableOnInteraction: false }}
      loop={true}
      // modules={[Navigation, Pagination, Autoplay]}
      // slidesPerView={1}
      // breakpoints={breakpoints}
      // autoplay={{ delay: 2000, disableOnInteraction: false }}
      // loop={true}
      className="category-slider"
    >
      {data &&
        data.map((item, index) => {
          return (
            <SwiperSlide>
              <div
                className="category-box-h3"
                key={index}
                onClick={() => navigate(`/view-category/${item.id}`)}
              >
                <div className="category-box">
                  <img src={item.imgUrl} alt="category" />
                </div>
                <h3>{item.name}</h3>
              </div>
            </SwiperSlide>
          );
        })}
    </Swiper>
  );
};
